// helpers
import { useFetch } from "./reactQuery";
import API_URLS from "@/api/routes.constant";

// interfaces
import { QueryArgsInterface } from "@/types/api/queryArgs";
import { IFacets } from "@/types/api/Facets";
import { IPaginatedResponse } from "@/types/api/PaginatedResponse";
import { ISingleSearch } from "@/types/api/SingleSearchResponse";

const search = {
  useSearchCount: (args?: QueryArgsInterface) => {
    const { params, config } = args || {};

    return useFetch<{ locationsCount: number; spacesCount: number; facets: IFacets; }>(
      API_URLS.searchUrls.resultsCount,
      params,
      config
    );
  },
  useSearch: (args?: QueryArgsInterface) => {
    const { params, config } = args || {};

    return useFetch<IPaginatedResponse<ISingleSearch> & { facets: IFacets }>(
      API_URLS.searchUrls.search, params, config
    );
  },
};

export default search;
